import "@/app/globals.css";
import { Root } from "@/app/root";
import { ThemeBridge } from "@/app/theme-bridge";
import "@galaxy-io/dls/fonts.css";
import "@galaxy-io/dls/styles.css";
import GalaxyProvider from "@galaxy-io/dls/theme/GalaxyProvider";
import "@galaxy-io/dls/tokens.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { themeStorage } from "@/lib/theme";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Collection keeps moving; a short stale window keeps lists honest
      // without refetching on every focus change.
      staleTime: 15_000,
      retry: (count, error) =>
        // Never retry a refusal; retrying an auth failure just delays the
        // login screen.
        count < 2 && !(error as { status?: number }).status?.toString().startsWith("4"),
    },
  },
});

const container = document.getElementById("root");
if (!container) throw new Error("missing #root");

createRoot(container).render(
  <StrictMode>
    <GalaxyProvider storage={themeStorage}>
      <QueryClientProvider client={queryClient}>
        <ThemeBridge />
        <Root />
      </QueryClientProvider>
    </GalaxyProvider>
  </StrictMode>,
);
